// src/signOut.js
// Centralized sign-out handler for Cognito OIDC.
//
// CRITICAL: We must redirect to Cognito's /logout endpoint FIRST, before
// clearing any local state. If we clear local OIDC tokens first, React
// re-renders, the useEffect in App.js detects isAuthenticated=false and
// fires signinRedirect() — which races against our window.location.href
// redirect. Because the Cognito server session is still alive, Cognito
// silently re-authenticates the user, making sign-out appear broken.
//
// The correct flow is:
// 1. Redirect to Cognito /logout (kills server session)
// 2. Cognito redirects back to logout_uri (our app)
// 3. App loads, OIDC library finds no valid session
// 4. useEffect fires signinRedirect() → Cognito login screen

export function performSignOut() {
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID || "mb8qm5hjm4h4if90qbetgtnls";
  const logoutUri = encodeURIComponent(window.location.origin);
  const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN || "https://ap-south-11j2oy3yf8.auth.ap-south-1.amazoncognito.com";
  const domain = cognitoDomain.replace(/\/$/, "");

  // Clear local storage synchronously before redirect to prevent auto-re-auth
  // on the return trip. This is safe because the redirect below is synchronous
  // and happens before React can re-render.
  try {
    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith('oidc.')) sessionStorage.removeItem(key);
    }
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('oidc.')) localStorage.removeItem(key);
    }
  } catch (e) {
    // Storage cleanup is best-effort; redirect will still work
  }

  // Redirect immediately — this is the critical line. The browser navigates
  // away before React can re-render and trigger signinRedirect().
  window.location.replace(`${domain}/logout?client_id=${clientId}&logout_uri=${logoutUri}`);
}
